module.exports = __webpack_public_path__ + "img/logo.9d2cb580.png";